import { Extension } from "@tiptap/core"

export const TableSelectAllExtension = Extension.create({
    name: "tableSelectAll",

    addKeyboardShortcuts() {
        return {
            "Mod-a": ({ editor }) => {
                const { state } = editor
                const { selection } = state
                const { $from } = selection

                let tableNode = $from.node(-1)
                if (tableNode?.type.name === "tableCell") {
                    tableNode = $from.node(-3)
                }

                if (tableNode?.type.name === "table") {
                    const tablePos = $from.start(-3)
                    const tableEnd = tablePos + tableNode.nodeSize

                    editor.commands.setTextSelection({ from: tablePos, to: tableEnd })

                    return true
                }

                return false
            }
        }
    }
})
